import { faWalking } from '@fortawesome/free-solid-svg-icons'
import { faDesktop, faPhone } from '@fortawesome/pro-solid-svg-icons'
import React, { FunctionComponent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Spinner } from '../../../App/Components'
import { DashBoardCardTitle, DashboardCardTopLeftContainer } from '../styles'

import { Client } from './Client/Client'
import { ITotalAppointments } from './Client/ITotalAppointments'
import { IProps } from './IProps'
import {
  NoAppointmentsLabel,
  TotalAppointmentInfoText,
  TotalAppointmentsCardContainer,
  TotalAppointmentsIcon,
  TotalAppointmentsInfoWrapper,
} from './style'

export const TotalAppointmentsCards: FunctionComponent<IProps> = ({
  from,
  to,
  windowWidth,
}) => {
  const { t } = useTranslation()

  const [totalAppointments, setTotalAppointments] =
    useState<ITotalAppointments>()

  useEffect(() => {
    Client.getAppointmentStatistics(from, to).then(newStatistics => {
      setTotalAppointments(newStatistics)
    })
  }, [from, to])

  if (!from || !to) {
    return <Spinner />
  }

  return (
    <DashboardCardTopLeftContainer windowWidth={windowWidth}>
      <DashBoardCardTitle>
        {t('Total appointments').toUpperCase()}
      </DashBoardCardTitle>

      <TotalAppointmentsCardContainer>
        {totalAppointments ? (
          <>
            <TotalAppointmentsInfoWrapper>
              <TotalAppointmentsIcon icon={faPhone} windowWidth={windowWidth} />
              <TotalAppointmentInfoText windowWidth={windowWidth}>
                {t('Appointments by phone')}
              </TotalAppointmentInfoText>
              <TotalAppointmentInfoText windowWidth={windowWidth}>
                {totalAppointments.phoneAppointments}
              </TotalAppointmentInfoText>
            </TotalAppointmentsInfoWrapper>
            <TotalAppointmentsInfoWrapper>
              <TotalAppointmentsIcon
                icon={faDesktop}
                windowWidth={windowWidth}
              />
              <TotalAppointmentInfoText windowWidth={windowWidth}>
                {t('Online appointments')}
              </TotalAppointmentInfoText>
              <TotalAppointmentInfoText windowWidth={windowWidth}>
                {totalAppointments.onlineAppointments}
              </TotalAppointmentInfoText>
            </TotalAppointmentsInfoWrapper>
            <TotalAppointmentsInfoWrapper>
              <TotalAppointmentsIcon
                icon={faWalking}
                windowWidth={windowWidth}
              />
              <TotalAppointmentInfoText windowWidth={windowWidth}>
                {t('Walk-ins without appointment')}
              </TotalAppointmentInfoText>
              <TotalAppointmentInfoText windowWidth={windowWidth}>
                {totalAppointments.walkInAppointments}
              </TotalAppointmentInfoText>
            </TotalAppointmentsInfoWrapper>
          </>
        ) : (
          <NoAppointmentsLabel>
            {t('There is no appointment data available 📅')}
          </NoAppointmentsLabel>
        )}
      </TotalAppointmentsCardContainer>
    </DashboardCardTopLeftContainer>
  )
}
